import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShareAlt, faCheck } from '@fortawesome/free-solid-svg-icons'
import {
  formatPrice,
  formatDiscount,
  formatPrecentage
} from '../../../helpers'

const ProductInfo = ({
  productPayload,
  account,
  referralDiscount = null,
  handleGoBack,
  handleAddToCart,
  handleShareNative,
  copied
}) => {
  if (!productPayload) return null

  const precentage = formatPrecentage(account, productPayload.discount, referralDiscount)
  const outOfStock = productPayload.has_stock === false || productPayload.has_stock === 0 || productPayload.has_stock === '0' || productPayload.has_stock === 'false' || productPayload.hasStock === false

  return (
    <div className="cover-detail">
      <div style={{ position: 'relative' }}>
        <img
          src={process.env.REACT_APP_IMAGE_URL + productPayload.image}
          alt={productPayload.name}
        />
        {outOfStock && (
          <span style={{
            position: 'absolute',
            top: '12px',
            left: '12px',
            backgroundColor: '#6c757d',
            color: '#ffffff',
            padding: '6px 12px',
            borderRadius: '6px',
            fontSize: '12px',
            fontWeight: 600,
            letterSpacing: '0.5px',
            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
            zIndex: 2
          }}>
            Stok Habis
          </span>
        )}
      </div>
      <div className="content-detail">
        <h2 className="judul">{productPayload.name}</h2>
        <div className="harga">
          <p>Harga</p>
          <div className="cover-harga">
            <p className="diskon">{precentage}%</p>
            <p className="harga-diskon">{formatPrice(productPayload.price, 'Rp.')}</p>
            <p className="harga-produk">
              {
                formatDiscount(
                  productPayload.price,
                  precentage,
                  'Rp.'
                )
              }
            </p>
          </div>
        </div>
        <div className="produsen">
          <p className="label-produsen">Produsen</p>
          <p className="nama-produsen">{productPayload.producer?.name}</p>
        </div>
        <div className="berat">
          <p className="label-berat">Berat</p>
          <p className="volume-berat">{productPayload.weight}</p>
        </div>
        <div className="btn-cover">
          <div className="btn-cover-left">
            {outOfStock ? (
              <a className="btn-bagikan btn-bagikan-disabled">
                <FontAwesomeIcon icon={copied ? faCheck : faShareAlt} /> {copied ? 'Tersalin!' : 'Bagikan'}
              </a>
            ) : (
              <a onClick={handleShareNative} className="btn-bagikan">
                <FontAwesomeIcon icon={copied ? faCheck : faShareAlt} /> {copied ? 'Tersalin!' : 'Bagikan'}
              </a>
            )}
          </div>
          <div className="btn-cover-right">
            <a onClick={handleGoBack} className="btn-kembali">Kembali</a>
            {outOfStock ? (
              <a className="btn-keranjang btn-keranjang-disabled">Stok Habis</a>
            ) : (
              <a onClick={handleAddToCart} className="btn-keranjang">Masukan keranjang</a>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductInfo
